import "./style.less";

export default function ToggleRadioSwitch() {
    return {
        scope: {
            model: "=",
            labelOn: "@",
            labelOff: "@",
        },
        template: require("./template.html"),

        controller: function () {},
    };
}
